import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

/**
 * BottomCTA — reusable navy silk CTA strip used at the bottom of inner pages.
 */
export default function BottomCTA({
  eyebrow = "Get in Touch",
  title = "Build with us.",
  accent = "For generations.",
  body = "Connect with us to explore investment and partnership opportunities aligned with long-term value creation.",
  primary = { label: "Contact Us", to: "/contact" },
  secondary = { label: "Our Portfolios", to: "/investments" },
}) {
  return (
    <section
      data-testid="bottom-cta"
      className="relative text-white overflow-hidden"
    >
      <div className="absolute inset-0 silk-bg" />
      <div className="absolute inset-0 grain pointer-events-none opacity-[0.04]" />
      <div
        className="absolute -top-32 -right-32 w-[480px] h-[480px] rounded-full pointer-events-none"
        style={{
          background:
            "radial-gradient(circle, rgba(233,195,123,0.18), transparent 60%)",
        }}
      />

      <div className="relative z-10 mx-auto max-w-[1400px] px-6 lg:px-10 py-24 lg:py-32">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-7">
            <div data-reveal className="flex items-center gap-4 text-unik-gold">
              <span className="w-12 h-px bg-unik-gold" />
              <span className="eyebrow">{eyebrow}</span>
            </div>
            <h2
              data-reveal
              style={{
                "--reveal-delay": "120ms",
                fontSize: "clamp(2.25rem, 5vw, 4.5rem)",
                fontWeight: 500,
                lineHeight: "1.0",
              }}
              className="mt-8 font-display tracking-tight"
            >
              {title}{" "}
              <span className="text-unik-gold">{accent}</span>
            </h2>
            <p
              data-reveal
              style={{ "--reveal-delay": "240ms" }}
              className="mt-8 max-w-xl text-white/80 text-[15px] lg:text-base leading-[1.95]"
            >
              {body}
            </p>
          </div>
          <div
            data-reveal
            style={{ "--reveal-delay": "360ms" }}
            className="lg:col-span-5 flex flex-wrap items-center gap-8 lg:justify-end"
          >
            <Link
              to={primary.to}
              className="group inline-flex items-center gap-3 px-10 py-4 rounded-full border border-unik-gold text-unik-gold font-display text-sm tracking-wide hover:bg-unik-gold hover:text-[#14355a] transition-all duration-500"
              data-testid="cta-primary"
            >
              {primary.label}
              <ArrowUpRight size={16} />
            </Link>
            <Link
              to={secondary.to}
              className="link-rule text-white text-sm hover:text-unik-gold"
              data-testid="cta-secondary"
            >
              {secondary.label}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
